/**
 * Formateo de bloques Completar para impresión — sin auto-spoiler.
 */

const BLANK_TOKEN = /\[BLANK\]|\[[^\]]+\]/g;
const BLOCK_SUFFIX_RE = /\s*·\s*(bloque\s*)?\d+\s*$/i;
const DEBUG_TITLE_RE = /\b(reference|debug|test|demo)\b/i;

/** Título narrativo para papel — sin ecuaciones ni sufijos de bloque. */
export function cleanCompletarPrintTitle(raw: string, fallback = 'Práctica guiada'): string {
  let title = String(raw || '').trim();
  title = title.replace(BLOCK_SUFFIX_RE, '').trim();
  title = title.replace(/^completar\s*·\s*/i, '').trim();
  if (!title || DEBUG_TITLE_RE.test(title) || /÷|=|\d+\s*[×x]\s*\d+/i.test(title)) {
    return fallback;
  }
  if (title.length > 88) {
    return `${title.slice(0, 85)}…`;
  }
  return title;
}

export type CompletarPrintSegment =
  | { kind: 'text'; value: string }
  | { kind: 'blank'; placeholder?: string };

/** Parte el texto en segmentos visibles y casilleros vacíos (nunca revela respuestas). */
export function parseCompletarPrintSegments(text: string): CompletarPrintSegment[] {
  const source = String(text || '');
  if (!source.trim()) return [];

  const segments: CompletarPrintSegment[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  const re = new RegExp(BLANK_TOKEN.source, 'g');
  while ((match = re.exec(source)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ kind: 'text', value: source.slice(lastIndex, match.index) });
    }
    const inner = match[0].replace(/^\[|\]$/g, '').trim();
    const placeholder = inner === 'BLANK' ? undefined : undefined;
    segments.push({ kind: 'blank', placeholder });
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < source.length) {
    segments.push({ kind: 'text', value: source.slice(lastIndex) });
  }

  return segments;
}

/** Normaliza texto de consigna: convierte respuestas entre corchetes a [BLANK] para almacenamiento mixto. */
export function normalizeCompletarTextForStorage(text: string): string {
  return String(text || '').replace(BLANK_TOKEN, '[BLANK]');
}
